'use strict';

/**
 * Sample Element Service
 */
module.service('productService', [ 'Restangular', '$q', function(Restangular, $q) {

    /*
     * ------------------------------------------------------------------------------
     * SERVICE FUNCTIONS
     * -------------------------------------------------------------------------------
     */
    var productResource = Restangular.all('product');

    return {

        searchProducts : function(filters) {
            var deferred = $q.defer();
            var answer = new restResponse();

            productResource.customGET('', filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        searchProductsBasicInfo : function(filters) {
            var deferred = $q.defer();
            var answer = new restResponse();

            productResource.customGET('basicinfo', filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        createProduct : function(createModel) {
            var deferred = $q.defer();
            var answer = new restResponse();

            productResource.post(createModel).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });

            return deferred.promise;
        },

        loadProduct : function(id) {
            var deferred = $q.defer();
            var answer = new restResponse();
            productResource.get(id).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        updateProduct : function(id, updateModel) {
            var deferred = $q.defer();
            var answer = new restResponse();
            Restangular.one('product', id).customPUT(updateModel).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        removeProduct : function(id) {
            var deferred = $q.defer();
            var answer = new restResponse();
            Restangular.one('product', id).remove().then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        associateRegulations : function(idProduct,idRegulation, updateModel) {
            var deferred = $q.defer();
            var answer = new restResponse();
            Restangular.one('product', idProduct).customPOST(updateModel, 'regulation/'+idRegulation).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        updateAssociateRegulations : function(idProduct,idRegulation, updateModel) {
            var deferred = $q.defer();
            var answer = new restResponse();
            Restangular.one('product', idProduct).customPUT(updateModel, 'regulation/'+idRegulation).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        getRegulationsOfProduct : function(idProduct) {
            var deferred = $q.defer();
            var answer = new restResponse();
            Restangular.one('product', idProduct).customGET('regulation').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        desassociateRegulations : function(idProduct, idRegulation) {
            var deferred = $q.defer();
            var answer = new restResponse();
            Restangular.one('product', idProduct).customDELETE('regulation/' + idRegulation).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

    };
} ]);